import React from 'react';
import { Stack, ToggleButton } from '@mui/material';
import { StyledToggleButtonGroup } from 'components/StyledComponent';

interface IProps {
  selectedParts: number;
  setSelectedParts: (parts: number) => void;
  input?: React.MutableRefObject<HTMLInputElement>;
  parts: Part[];
  size?: string;
}

export function PartsList({
  selectedParts,
  setSelectedParts,
  input,
  parts,
  size = 'large',
}: IProps) {
  const handleParts = (
    event: React.MouseEvent<HTMLElement>,
    newParts: number,
  ) => {
    setSelectedParts(newParts);

    if (input) {
      input.current.focus();
    }
  };

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      mb={1}
    >
      <StyledToggleButtonGroup
        size={size}
        value={selectedParts}
        exclusive
        onChange={handleParts}
        aria-label='부위'
        sx={{ flexFlow: 'wrap' }}
      >
        {parts.map((part) => (
          <ToggleButton
            value={part.id}
            aria-label={part.name}
            key={part.id}
            color='primary'
          >
            {part.name}
          </ToggleButton>
        ))}
      </StyledToggleButtonGroup>
    </Stack>
  );
}
